import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestPackList = ({ categoryId = '', url = '' }) => {
  let apiUrl = '/user/pack/list';
  if (categoryId) {
    apiUrl += `/${categoryId}`;
  }
  if (url) {
    apiUrl += `/${url}`;
  }
  const result = apiClient.get(
    apiUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestAllPackList = ({ pageNumber, type }) => {
  let getUrl = '/user/pack/all_list';
  getUrl += `/${type}`;
  if (pageNumber) {
    getUrl += `/${pageNumber}`;
  }
  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestPackCardList = ({ pageNumber, packId }) => {
  let getUrl = '/user/pack/card_list';
  getUrl += `/${packId}`;
  if (pageNumber) {
    getUrl += `/${pageNumber}`;
  }
  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestPackDetail = ({ packId }) => {
  const result = apiClient.get(
    `/user/pack/detail/${packId}`,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestCheckPack = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/pack/check',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestSavePackPassword = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/pack/save_pass_log',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestBuyPack = ({ csrfToken }) => {
  const result = apiClient.post(
    '/user/pack/buy',
    { csrfToken },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestGachaResult = () => {
  const result = apiClient.get(
    '/user/pack/gache_result',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestBuyPackResult = () => {
  const result = apiClient.get(
    '/user/pack/buy_result',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestDividePackCard = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/pack/decision',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestPostPackList = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/pack/list',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestPackList,
  requestAllPackList,
  requestPackCardList,
  requestPackDetail,
  requestCheckPack,
  requestSavePackPassword,
  requestBuyPack,
  requestGachaResult,
  requestBuyPackResult,
  requestDividePackCard,
  requestPostPackList,
};
